module.exports = __webpack_public_path__ + "static/media/new-to-msd.90fb8303.jpg";